import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-56">
      <div className="max-w-3xl mx-auto" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border-2 border-[#C4A7E7] text-center relative overflow-hidden" data-id="element-58">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#C4A7E7]" data-id="element-59"></div>

          <div className="flex justify-center mb-6" data-id="element-60">
            <div className="bg-[#C4A7E7]/15 p-4 rounded-full" data-id="element-61">
              <ShieldCheckIcon className="w-16 h-16 text-[#C4A7E7]" data-id="element-62" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-[#111111] mb-6" data-id="element-63">
            GARANTÍA TOTAL 7 DÍAS
          </h2>

          <p className="text-xl text-gray-700 mb-8 font-medium" data-id="element-64">
            Usá todo el material durante una semana completa.
          </p>

          <div className="text-left max-w-md mx-auto mb-8 bg-gray-50 p-6 rounded-2xl" data-id="element-65">
            <p className="font-bold text-[#111111] mb-4" data-id="element-66">Si no sentís:</p>
            <ul className="space-y-3" data-id="element-67">
              <li className="flex items-start gap-3" data-id="element-68">
                <CheckIcon className="w-5 h-5 text-[#C4A7E7] flex-shrink-0 mt-0.5" data-id="element-69" />
                <span className="text-gray-700" data-id="element-70">
                  Más claridad sobre qué hacer en cada sesión
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-71">
                <CheckIcon className="w-5 h-5 text-[#C4A7E7] flex-shrink-0 mt-0.5" data-id="element-72" />
                <span className="text-gray-700" data-id="element-73">
                  Menos estrés buscando y preparando material
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-74">
                <CheckIcon className="w-5 h-5 text-[#C4A7E7] flex-shrink-0 mt-0.5" data-id="element-75" />
                <span className="text-gray-700" data-id="element-76">
                  Al menos un avance concreto y observable en el niño
                </span>
              </li>
            </ul>
          </div>

          <p className="text-xl text-gray-700 leading-relaxed" data-id="element-77">
            Te devolvemos el{' '}
            <strong className="text-[#C4A7E7] font-black text-2xl" data-id="element-78">
              100% del dinero.
            </strong>
            <br data-id="element-79" />
            Sin preguntas. Sin formularios. Sin vueltas.
          </p>
        </motion.div>
      </div>
    </section>;
}